export default  {
  bindings: {
    option: '=',
    treatments: '<',
    days: '<',
    title: '@'
  },
  controller: 'optionsSaveController',
  template: require('../views/options.save.html')
};



// WEBPACK FOOTER //
// ./frontend/admin/app/modules/event/components/options.save.component.js